



























































import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw';
import { DrawAnglesChartSVG } from '@/plugins/podolib/services/charts/prosup-chart/angles-prosup-running';

@Component
export default class ChartRunningPronationSupinationAngles extends Mixins(MixinChartRaw) {
  @Prop({ default: false, required: false }) relativeMode!: boolean;
  @Prop({ default: false }) isNewAnalysis!: boolean;
  @Prop({ required: false, default: null }) height!: number;

  graphCanvas: DrawAnglesChartSVG | null = null;
  parentWidth = this.simple ? 800 : 600;
  width = this.simple ? 800 : 700;

  data: any = {
    propulsionPhase: {},
    brakingPhase: {},
    propulsion: {},
    flatFoot: {},
    strike: {},
  };
  // TODO : remove
  ranges: any = {
    base: {
      min: 0,
      max: 0,
    },
    minRange: {
      min: 0,
      max: 0,
    },
    maxRange: {
      min: 0,
      max: 0,
    },
    extremMin: 0,
    extremMax: 0,
  };

  // Phases
  get propulsionPhase() {
    return {
      left: {
        abs: this.getPhaseDuration('left', 'propulsive_phase'),
        rel: this.values.computed_data.aggregates.left.propulsive_phase!.avg,
        ranges: {
          background: 'rgba(216,220,225,0.35)',
          text: '#5DD0AC',
          chevron: null,
        },
      },
      right: {
        abs: this.getPhaseDuration('right', 'propulsive_phase'),
        rel: this.values.computed_data.aggregates.right.propulsive_phase!.avg,
        ranges: {
          background: 'rgba(216,220,225,0.35)',
          text: '#5DD0AC',
          chevron: null,
        },
      },
    };
  }
  get brakingPhase() {
    return {
      left: {
        abs: this.getPhaseDuration('left', 'braking_phase'),
        rel: this.values.computed_data.aggregates.left.braking_phase!.avg,
        ranges: {
          background: 'rgba(216,220,225,0.35)',
          text: '#5DD0AC',
          chevron: null,
        },
      },
      right: {
        abs: this.getPhaseDuration('right', 'braking_phase'),
        rel: this.values.computed_data.aggregates.right.braking_phase!.avg,
        ranges: {
          background: 'rgba(216,220,225,0.35)',
          text: '#5DD0AC',
          chevron: null,
        },
      },
    };
  }

  // Angles
  get propulsion() {
    return {
      left: this.values.computed_data.aggregates.left.angle_foot_out.avg,
      right: this.values.computed_data.aggregates.right.angle_foot_out.avg,
      leftStd: this.values.computed_data.aggregates.left.angle_foot_out.std,
      rightStd: this.values.computed_data.aggregates.right.angle_foot_out.std,
    };
  }
  get flatFoot() {
    return this.isNewAnalysis
      ? {
          left: this.values.computed_data.aggregates.left.angle_flat_foot.avg,
          right: this.values.computed_data.aggregates.right.angle_flat_foot.avg,
          leftStd: this.values.computed_data.aggregates.left.angle_flat_foot.std,
          rightStd: this.values.computed_data.aggregates.right.angle_flat_foot.std,
        }
      : {
          left: 0,
          right: 0,
          leftStd: 0,
          rightStd: 0,
        };
  }
  get strike() {
    return {
      left: this.values.computed_data.aggregates.left.angle_foot_in.avg,
      right: this.values.computed_data.aggregates.right.angle_foot_in.avg,
      leftStd: this.values.computed_data.aggregates.left.angle_foot_in.std,
      rightStd: this.values.computed_data.aggregates.right.angle_foot_in.std,
    };
  }

  // Get mode Relatif or Absolute
  get dataMode(): string {
    return this.relativeMode ? 'rel' : 'abs';
  }
  get responsiveData() {
    return [
      {
        angle: {
          id: 'propulsion',
          name: this.$t('commons.standards.propulsion'),
          left: this.propulsion.left,
          right: this.propulsion.right,
        },
        timePhase: {
          id: 'digit',
          icon: require(`@/assets/images/propulsion.svg`),
          left: this.propulsionPhase.left.abs,
          right: this.propulsionPhase.right.abs,
        },
      },
      {
        angle: {
          id: 'flatFoot',
          name: this.$t('commons.standards.flatfoot'),
          left: this.flatFoot.left,
          right: this.flatFoot.right,
        },
        timePhase: {
          id: 'tali',
          icon: require(`@/assets/images/heel-strike.svg`),
          left: this.brakingPhase.left.abs,
          right: this.brakingPhase.right.abs,
        },
      },
      {
        angle: {
          id: 'strike',
          name: this.$t('commons.standards.strike'),
          left: this.strike.left,
          right: this.strike.right,
        },
        timePhase: null,
      },
    ];
  }

  @Watch('parentWidth', { deep: true })
  onParentWidthChange() {
    this.getAllData();
    this.draw();
  }
  @Watch('relativeMode', { deep: true })
  onModeChange() {
    this.getAllData();
    this.draw();
  }
  @Watch('values', { deep: true })
  onValuesChange() {
    this.getAllData();
    this.draw();
  }

  getAngleRange(angle: number, type: string) {
    const range = this.$pdc.helper?.runningAngleAverage[type];
    switch (true) {
      case angle < range.min:
        return 'low-range';
      case angle > range.max:
        return 'high-range';
      default:
        return 'good-range';
    }
  }
  getPhaseRange(phase: number, type: string, side: string) {
    const range = this.ranges;

    const val = this.relativeMode ? this.getPercentPhase(side, phase) : phase;

    switch (true) {
      case val >= range.base.min && val <= range.base.max:
        return {
          class: 'good-range',
          ranges: {
            background: 'rgba(216,220,225,0.35)',
            text: '#5DD0AC',
            chevron: null,
          },
        };
      case val >= range.minRange.min && val < range.minRange.max:
        return {
          class: 'low-range warning-range',
          ranges: {
            background: 'rgba(255,189,26,0.15)',
            text: '#ffbd1a',
            chevron: 'down',
          },
        };
      case val > range.maxRange.min && val <= range.maxRange.max:
        return {
          class: 'high-range warning-range',
          ranges: {
            background: 'rgba(255,189,26,0.15)',
            text: '#ffbd1a',
            chevron: 'up',
          },
        };
      case val < range.minRange.min:
        return {
          class: 'low-range bad-range',
          ranges: {
            background: 'rgba(255,94,19,0.15)',
            text: '#ff5e13',
            chevron: 'down',
          },
        };
      case val > range.maxRange.max:
        return {
          class: 'high-range bad-range',
          ranges: {
            background: 'rgba(255,94,19,0.15)',
            text: '#ff5e13',
            chevron: 'up',
          },
        };
    }
  }
  getPercentPhase(side: string, value: number): number {
    const total = 560;
    /*this.values.computed_data[side].aggregates.time_taligrade_phase.avg +
      this.values.computed_data[side].aggregates.time_plantigrade_phase.avg +
      this.values.computed_data[side].aggregates.time_digitigrade_phase.avg;*/
    const result = (value / total) * 100;
    return this.roundNumber(result);
  }
  roundNumber(val: number) {
    return parseFloat(val.toFixed(0));
  }
  getPhaseDuration(side: string, phase: string) {
    const contactTime = this.values.computed_data.aggregates[side].contact_time.avg;
    const phaseRel = this.values.computed_data.aggregates[side][phase].avg;
    return (contactTime / 100) * phaseRel * 1000;
  }
  // Draw
  getAllData() {
    for (const val of ['propulsionPhase', 'brakingPhase', 'propulsion', 'flatFoot', 'strike']) {
      // @ts-ignore
      this.data[val] = this[val];
    }
    this.draw();
  }
  draw() {
    this.graphCanvas = new DrawAnglesChartSVG(
      this.$refs['canvas'] as HTMLCanvasElement,
      this.$refs['canvasTooltip'] as HTMLCanvasElement,
      this.parentWidth,
      this.data,
      this.$pdc.helper?.runningAngleAverage,
      this.dataMode,
    );
    requestAnimationFrame(() => {
      this.graphCanvas!.draw();
    });
  }

  handleResize() {
    const parent: any = this.$refs['canvasContent'];
    this.parentWidth = parent.clientWidth;
    this.width = window.innerWidth;
  }

  mounted() {
    const parent: any = this.$refs['canvasContent'];
    this.parentWidth = parent.clientWidth;
    this.width = window.innerWidth;
    this.getAllData();
    this.draw();
  }
  created() {
    window.addEventListener('resize', this.handleResize);
  }
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
}
